import React from 'react';
import './TLDRBox.css';

const TLDRBox = ({ title = 'Quick Takeaways', children }) => {
  if (!children) return null;

  return (
    <div className="tldr-box">
      <div className="tldr-box__badge">📌</div>
      <div>
        <h3>{title}</h3>
        <div className="tldr-box__content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default TLDRBox;
